import { Box, Typography } from '@mui/material';
import Topbar from '../../../Components/Topbar/Topbar';
import EditAnnouncementForm from '../EditAnnouncementForm/EditAnnouncementForm';
import { useNavigate } from 'react-router-dom';

const AnnouncementsCreate = () => {
  const navigate = useNavigate();

  return (
    <Box className="min-h-[110vh]">
      <Topbar title="Ηλεκτρονικές Υπηρεσίες" />
      <Typography
        className="pt-6 pb-5 pl-4"
        variant="h3"
        color={'#003375'}
        gutterBottom
      >
        <span
          className="cursor-pointer hover:underline"
          onClick={() => navigate('/announcements')}
          style={{ color: '#003375' }}
        >
          Οι ανακοινώσεις μου
        </span>
        <span style={{ color: '#003375' }}> / Προσθήκη νέας</span>
      </Typography>

      <Box className="flex flex-col w-full justify-right items-end pb-5 pl-4 pr-4">
        <EditAnnouncementForm isCreateModeOn />
      </Box>
    </Box>
  );
};

export default AnnouncementsCreate;
